import { call, put } from 'typed-redux-saga'
import * as bankSessionActions from '../../actions/consumerDataPullSessionActions/bankSessionActions'
import { api as signalRApi } from '../../../../../api/signalRApi'
import { transactionApiClient } from '../../../../../api/transactionApiClient'
import {
	CreateBankSessionAction,
	getAllBankSessions as getAllBankSessionsAction,
	createBankSessionFailed as createBankSessionFailedAction,
	getAllBankSessionsSucceeded as getAllBankSessionsSucceededAction,
	getAllBankSessionsFailed as getAllBankSessionsFailedAction,
} from '../../actions/consumerDataPullSessionActions/bankSessionActions'

export function* getAllBankSessionsSaga(): Generator {
	try {
		yield put(bankSessionActions.clearErrors())
		const allBankSessions = yield* call(transactionApiClient.getBankSessions)
		yield put(getAllBankSessionsSucceededAction(allBankSessions))
	} catch (error: any) {
		yield put(getAllBankSessionsFailedAction(error))
	}
}

export function* createBankSessionSaga(
	action: CreateBankSessionAction,
): Generator {
	try {
		const { bankId, consentCode, authUrl } = action.payload
		yield* call(() =>
			signalRApi.createBankSession(bankId, consentCode, authUrl),
		)
	} catch (error: any) {
		yield put(createBankSessionFailedAction(error))
	}
}

export function* createBankSessionSucceededSaga(): Generator {
	yield put(getAllBankSessionsAction())
}
